// utils
import { cn } from '@/utils';

interface EmptyViewProps {
    className?: string;
}

const EmptyView = ({ className }: EmptyViewProps) => {
    return (
        <div
            className={cn(
                'flex items-center justify-center text-gray-6 rounded-lg border-2 border-dashed border-gray-3 text-sm md:text-base',
                className
            )}
        >
            No sessions in selected time period
        </div>
    );
};

export default EmptyView;
